import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { propertiesResolver } from '@core/resolvers/properties-resolver';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('@features/auth/components/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    resolve: { properties: propertiesResolver },
    children: [
      {
        path: '',
        loadComponent: () => import('@features/dashboard/components/dashboard/dashboard.component')
          .then(m => m.DashboardComponent)
      },
      {
        path: 'property/:propertyId',
        children: [
          {
            path: 'rooms',
            loadComponent: () => import('@features/rooms/components/room-list/room-list.component')
              .then(m => m.RoomListComponent)
          },
          {
            path: 'room/:roomId',
            loadComponent: () => import('@features/rooms/components/room-detail/room-detail.component')
              .then(m => m.RoomDetailComponent)
          },
          {
            path: 'add-room',
            loadComponent: () => import('@features/rooms/components/add-room/add-room')
              .then(m => m.AddRoom)
          }
        ]
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
